/**
 * Login page copy (SDD R-004). Step wording is provisional. The login page
 * renders only the support contact fields that are set, and no contact line
 * when none are.
 */

export const description =
  "YaBuddy provides announcements of a team's schedule via GroupMe.";

export const steps = [
  'Log in with GroupMe',
  "Pick your team's group",
  'Click Add YaBuddy',
];

/**
 * Who to contact for help; each field is optional.
 * @type {{name?: string|null, email?: string|null, phone?: string|null}}
 */
export const support_contact = {
  name: 'Mike Rochford',
  email: 'mike@mikerochford.com',
  phone: '952-240-5185',
};
